<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Grupos de Inventarios</h1>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Grupo de Inventario</label>
              <div class="control">
                <input
                  v-model="grupo.nombre"
                  class="input"
                  type="text"
                  placeholder="Nombre"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Porcentaje</label>
              <div class="control">
                <input
                  v-model="grupo.porcentaje"
                  class="input"
                  type="number"
                  placeholder="Porcentaje"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <button class="button is-primary" @click="saveGrupo()">
              Guardar
            </button>
            <button class="button" @click="cancel">Cancelar</button>
          </div>
        </div>
      </div>
      <div class="column notification">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Sub Grupos</h1>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Nomenclatura</label>
              <div class="control">
                <input
                  v-model="subgrupo.nomenclatura"
                  class="input"
                  type="text"
                  placeholder="Nombre"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Grupo de Inventario</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="subgrupo.grupo">
                    <option :value="null">Seleccionar Grupo</option>
                    <option
                      v-for="(item1, index1) in grupos"
                      :key="index1"
                      :value="item1._id"
                    >
                      {{ item1.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <button class="button is-primary" @click="saveSubgrupo()">
              Guardar
            </button>
            <button class="button" @click="cancel">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column">
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Porcentaje</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in grupos" :key="index">
              <td>{{ item.nombre }}</td>
              <td class="fontMono has-text-right">
                {{ item.porcentaje | number(2) }}%
              </td>
              <td>
                <div class="buttons has-addons">
                  <button class="button is-small" @click="edit(item)">
                    <span class="icon is-small">
                      <span class="material-icons"> mode_edit </span>
                    </span>
                  </button>
                  <button
                    class="button is-small is-danger"
                    @click="eliminar(item)"
                  >
                    <span class="icon is-small">
                      <span class="material-icons"> delete_forever </span>
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="column notification">
        <table class="table">
          <thead>
            <tr>
              <th>Nomenclatura</th>
              <th>Subgruop</th>
              <th>Porcentaje</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in subgrupos" :key="index">
              <td>{{ item.nomenclatura }}</td>
              <td>{{ item.grupo.nombre }}</td>
              <td class="fontMono has-text-right">
                {{ item.grupo.porcentaje | number(2) }}%
              </td>
              <td>
                <div class="buttons has-addons">
                  <button class="button is-small" @click="editsubgrupo(item)">
                    <span class="icon is-small">
                      <span class="material-icons"> mode_edit </span>
                    </span>
                  </button>
                  <button
                    class="button is-small is-danger"
                    @click="eliminarsubgrupo(item)"
                  >
                    <span class="icon is-small">
                      <span class="material-icons"> delete_forever </span>
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      subgrupo: {
        _id: null,
        nomenclatura: null,
        grupo: null,
      },
      grupo: {
        _id: null,
        nombre: null,
        porcentaje: null,
      },
      grupos: [],
      subgrupos: [],
    };
  },
  computed: {
    ...mapState(["modalnotification"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    eliminarsubgrupo(item) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Atención!",
          message: "Realmente desea eliminar el subgrupo de inventario?",
          clase: "is-danger",
          data: { id: item._id, tipo: "subgrupo" },
        },
      });
    },
    eliminar(item) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Atención!",
          message: "Realmente desea eliminar el grupo de inventario?",
          clase: "is-danger",
          data: { id: item._id, tipo: "grupo" },
        },
      });
    },
    async deletegrupo(data) {
      try {
        if (data.tipo === "grupo") {
          await apiServices.delete(`/deletegrupocomision/${data.id}`);
          this.findGrupos();
          this.findSubGrupos();
        } else {
          await apiServices.delete(`/deletesubgrupocomision/${data.id}`);
          this.findSubGrupos();
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancel() {
      this.grupo = {
        _id: null,
        nombre: null,
        porcentaje: null,
      };
      this.subgrupo = {
        _id: null,
        nomenclatura: null,
        grupo: null,
      };
    },
    editsubgrupo(subgrupo) {
      try {
        this.subgrupo._id = subgrupo._id;
        this.subgrupo.nomenclatura = subgrupo.nomenclatura;
        this.subgrupo.grupo = subgrupo.grupo._id;
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.log(err);
      }
    },
    async edit(grupo) {
      try {
        this.grupo = JSON.parse(JSON.stringify(grupo));
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.log(err);
      }
    },
    async saveSubgrupo() {
      try {
        if (!this.subgrupo.nomenclatura) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar una nomenclatura",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.subgrupo.grupo) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un grupo de Inventarios",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.subgrupo._id) {
          await apiServices.post(`/editsubgrupocomision`, this.subgrupo);
        } else {
          await apiServices.post(`/createsubgrupocomision`, this.subgrupo);
        }
        this.subgrupo = {
          _id: null,
          nomenclatura: null,
          grupo: null,
        };
        this.findSubGrupos();
      } catch (err) {
        console.log(err);
      }
    },
    async saveGrupo() {
      try {
        if (!this.grupo.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar un nombre",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.grupo.porcentaje) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar un porcentaje",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.grupo._id) {
          await apiServices.post(`/editgrupocomision`, this.grupo);
        } else {
          await apiServices.post(`/creategrupocomision`, this.grupo);
        }
        this.grupo = {
          _id: null,
          nombre: null,
          porcentaje: null,
        };
        this.findGrupos();
        this.findSubGrupos();
      } catch (err) {
        console.log(err);
      }
    },
    async findGrupos() {
      try {
        const result = await apiServices.get(`/grupocomision`);
        if (result.data) {
          this.grupos = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findSubGrupos() {
      try {
        const result = await apiServices.get(`/subgrupocomision`);
        if (result.data) {
          this.subgrupos = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findGrupos();
    this.findSubGrupos();
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deletegrupo(this.modalnotification.result.data);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/comisiones/Productos.vue